<template>
  <Students />
</template>

<script>
import Students from '@/components/students/List.vue'

export default {
  name: 'StudentsList',
  components: { Students }
}
</script>

<style scoped>

</style>
